// extracted by mini-css-extract-plugin
var _1 = "GroupDetailContent-module__animatedBackground--RXgeu";
var _2 = "GroupDetailContent-module__banner--KeKCh";
var _3 = "120px";
var _4 = "GroupDetailContent-module__container--chj2q";
var _5 = "GroupDetailContent-module__content--w1qFf";
var _6 = "GroupDetailContent-module__description--PY_B8";
var _7 = "GroupDetailContent-module__hasSeparator--vcttF";
var _8 = "GroupDetailContent-module__headerContainer--ZejfE";
var _9 = "GroupDetailContent-module__members--fyZ7b";
var _a = "GroupDetailContent-module__title--I5AQ5";
var _b = "GroupDetailContent-module__titleContainer--XFWEp";
var _c = "GroupDetailContent-module__titleIcon--ckezO";
export { _1 as "animatedBackground", _2 as "banner", _3 as "bannerHeight", _4 as "container", _5 as "content", _6 as "description", _7 as "hasSeparator", _8 as "headerContainer", _9 as "members", _a as "title", _b as "titleContainer", _c as "titleIcon" }
